import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PixHelpComponent } from '../../pix/help/help.component';
import { LimiteTipoPeriodo, PeriodoLimiteModel } from '../models/limits';

@Component({
  selector: 'app-adjust-limit',
  templateUrl: './adjust-limit.component.html',
  styleUrls: ['./adjust-limit.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class LimitsAdjustLimitComponent implements OnInit {
	public title = '';
	public subtitle = '';
	public form: FormGroup;
	public selectedLimit: PeriodoLimiteModel= new PeriodoLimiteModel();

	constructor(
		private router: Router,
		private formBuilder: FormBuilder,
		public dialog: MatDialog,
	) { }

	ngOnInit() {
		this.selectedLimit = JSON.parse(sessionStorage.getItem('selectedlimitTransferData'));

		if (!this.validParams()) {
			this.goBack();
		} else {
			this.buildForm();
		}
	}

	get showCallCenterInfo(): boolean{
		return this.form.get('value').value > this.selectedLimit.valorMaximo;
	}

	get disableIncreaseMaxLimit(): boolean{
		return this.form.get('value').value > this.selectedLimit.valorMaximo;
	}

	buildForm(): void {
		this.form = this.formBuilder.group({
			type: [this.selectedLimit.tipo],
			value: [this.selectedLimit.valor, [Validators.required, Validators.min(0.01), Validators.max(this.selectedLimit.valorMaximo)]]
		});

		this.createTitleSubtitle();
	}

	createTitleSubtitle(): void {
		switch (this.selectedLimit.tipo) {
			case LimiteTipoPeriodo.PIX_DIURNO:
				this.title = 'Ajuste limite diurno';
				this.subtitle = 'Digite valor do limite para as transações Pix das ';
				break;
			case LimiteTipoPeriodo.PIX_NOTURNO:
				this.title = 'Ajuste limite noturno';
				this.subtitle = 'Digite valor do limite para as transações Pix das ';
				break;
			case LimiteTipoPeriodo.QRCODE_PIX_SAQUE_TROCO_DIURNO:
				this.title = 'Ajuste limite diurno';
				this.subtitle = 'Digite valor do limite para as transações Pix saque e troco das ';
				break;
			case LimiteTipoPeriodo.QRCODE_PIX_SAQUE_TROCO_NOTURNO:
				this.title = 'Ajuste limite noturno';
				this.subtitle = 'Digite valor do limite para as transações Pix saque e troco das ';
				break;
			case LimiteTipoPeriodo.TED_DIURNO:
				this.title = 'Ajustar limite TED';
				this.subtitle = 'Digite valor do limite para as transferências TED das ';
				break;
			default:
				break;
		}
	}

	showInfo(): void {
		this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}

	public submit(): void {
		if (this.form.valid) {

			this.selectedLimit.valor = this.form.get('value').value;
			this.saveSelectedAdjustedLimit(this.selectedLimit);
			this.router.url === '/minha-conta/meus-limites/alterar-limite' ? this.router.navigate(['/minha-conta/meus-limites/assinatura']) : this.router.navigate(['/pix/limites/assinatura']);
		}
	}

	public showInfoLimitZero(): boolean {
		return this.form.get('value').value === 0;
	}

	public getTextLimitZero(): string {
		const pixType = this.subtitle.charAt(0).toLowerCase() + this.subtitle.substr(1);
		return 'Atenção!<br> Ao definir o limite zerado, você ficará impossibilitado de realizar transações Pix ' + pixType;
	}

	public verifyZero(): void {
		if ($('.currency-field').val() === '0,00') {
			$('.currency-field').val('');
		}
	}

	private validParams(): boolean {
		return !!this.selectedLimit || !!this.selectedLimit.valor || !!this.selectedLimit.tipo;
	}

	public goBack = () => this.router.url === '/minha-conta/meus-limites/alterar-limite' ? this.router.navigate(['/minha-conta/meus-limites/selecionar-limite']) : this.router.navigate(['/pix/limites/selecionar-limite']);

	saveSelectedAdjustedLimit(data: PeriodoLimiteModel ): void {
		sessionStorage.removeItem('selectedAdjustedLimit');
		sessionStorage.setItem('selectedAdjustedLimit', JSON.stringify(data));
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limits/adjust-limit/adjust-limit.component.ts